import React from 'react';
import Link from 'next/link';
import CustomizeBox from '../components/CustomizeBox';
import { GalleryItemWithBundle, WhoIsWearingWithBundle } from '../types';
import { Disclosure } from '@headlessui/react';
import IconTriangleDown from '../components/IconTriangleDown';
import AnimateHeight from '../components/AnimateHeight';
import { getItemUrl } from 'utils/utils';

interface LightBoxItemProps {
  error: boolean;
  lightBoxItem: GalleryItemWithBundle | WhoIsWearingWithBundle;
}

type Props = React.FC<React.HTMLAttributes<HTMLDivElement> & LightBoxItemProps>;

const LightBoxItem: Props = ({ lightBoxItem, error, className, ...props }) => {
  return (
    <div {...props} className={` ${className ? className : ''}`}>
      {lightBoxItem.bundle ? (
        <>
          {lightBoxItem._type == 'galleryItem' && (
            <CustomizeBox
              item={lightBoxItem.bundle}
              isBlockedOut={false}
              isComingSoonBlockedOut={false}
              builderQueryString={`?bundle_ids=${lightBoxItem.bundle.id}`}
            />
          )}

          {lightBoxItem._type == 'whoIsWearing' && (
            <div className="text-h4-display">{lightBoxItem.bundle.display_name}</div>
          )}

          <Link href={'/collection/[category]/[product]'} as={getItemUrl(lightBoxItem.bundle)}>
            <a
              className={`tracker-cta-gallery-lightbox-20190218-171521 ${
                lightBoxItem._type === 'galleryItem' ? 'btn-info-outline' : 'btn-info'
              } btn pointer-events-auto mt-16 mb-32 block w-full`}
            >
              View Product
            </a>
          </Link>
        </>
      ) : (
        <div>
          <p className="text-gray">Product No Longer Available</p>
        </div>
      )}
      {!error && lightBoxItem.bundle && (
        <>
          <Disclosure as="div">
            {({ open }) => (
              <>
                <Disclosure.Button className="group flex w-full items-center justify-start">
                  <h3 className="text-h5 py-16 group-hover:text-gold-darker">Details</h3>

                  <IconTriangleDown
                    className={`ml-auto fill-current transition  duration-150 group-hover:text-gold-darker ${
                      open ? '' : 'rotate-90 transform'
                    }`}
                  />
                </Disclosure.Button>

                <AnimateHeight open={open}>
                  <Disclosure.Panel static className="pb-16">
                    {lightBoxItem.bundle.details!.map((d) => (
                      <p className="text-sm text-gray-dark" key={d.id}>
                        - {d.detail}
                      </p>
                    ))}
                  </Disclosure.Panel>
                </AnimateHeight>
              </>
            )}
          </Disclosure>

          <hr className="border-gray-light" />

          <Disclosure as="div">
            {({ open }) => (
              <>
                <Disclosure.Button className="group flex w-full items-center justify-start">
                  <h3 className="text-h5 py-16 group-hover:text-gold-darker">Stylist Notes</h3>

                  <IconTriangleDown
                    className={`ml-auto fill-current transition duration-150 group-hover:text-gold-darker ${
                      open ? '' : 'rotate-90 transform'
                    }`}
                  />
                </Disclosure.Button>

                <AnimateHeight open={open}>
                  <Disclosure.Panel static className="pb-16">
                    <p className="text-sm text-gray-dark">{lightBoxItem.bundle.short_description}</p>
                  </Disclosure.Panel>
                </AnimateHeight>
              </>
            )}
          </Disclosure>

          <hr className="border-gray-light" />
        </>
      )}
      {lightBoxItem._type == 'galleryItem' && (
        <div>
          <h5 className="text-h5  mb-8 mt-32">Tags</h5>
          {lightBoxItem.type && <p className="text-sm capitalize text-gray-dark">- {lightBoxItem.type}</p>}
          {lightBoxItem.category && <p className="text-sm capitalize text-gray-dark">- {lightBoxItem.category}</p>}
          {lightBoxItem.color && <p className="text-sm capitalize text-gray-dark">- {lightBoxItem.color}</p>}
        </div>
      )}
    </div>
  );
};

export default LightBoxItem;
